/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { IUser } from '../shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { MessageService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { AppUtils } from 'common/services/app.util';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { AuthService } from 'common/services/auth.service';


@Component({
  selector: 'app-login',
  templateUrl: './app.login.component.html',
})
export class AppLoginComponent {
  // @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;
  user: IUser;
  passwordType: string = "password";
  loading: boolean;
  tokenTimer: NodeJS.Timer;
  errorMessage: string = '';
  error: boolean = false;
  response: any;
  isDisableSignin: boolean = true;
  isCaptchaShow = false;
  isAutoLoggingIn = false;
  private autoLoginAttempted = false;

  constructor(
    private LanguageService: LanguageService,
    private appServicemanager: AppServiceManager,
    private http: HttpClient,
    private route: Router,
    private router: ActivatedRoute,
    private messageService: MessageService,
  ) {
    const params = this.router.snapshot.queryParamMap;
    const state = history.state as { email?: string; password?: string };
    const hasAutoLoginCredentials =
      (params.get('email') || state?.email) &&
      (params.get('password') || state?.password);

    if (hasAutoLoginCredentials) {
      this.isAutoLoggingIn = true;
      this.loading = true;
    }
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("AppLoginComponent", label);
  }
  ngOnInit() {
    this.applyAutoLogin(this.router.snapshot.queryParamMap);
    this.router.queryParamMap.subscribe(params => {
      this.applyAutoLogin(params);
    });
  }

  private applyAutoLogin(params: ParamMap): void {
    if (this.autoLoginAttempted) {
      return;
    }

    const state = history.state as { email?: string; password?: string };
    const emailParam = params.get('email') || state?.email;
    const passwordParam = params.get('password') || state?.password;

    if (emailParam && passwordParam) {
      this.autoLoginAttempted = true;
      this.isAutoLoggingIn = true;
      this.loading = true;
      this.user = new IUser();
      this.user.email = emailParam;
      this.user.password = passwordParam;
      this.login();
    } else if (!this.user) {
      this.user = new IUser();
    }
  }

  togglePasswordType() {
    if (this.passwordType === "password") {
      this.passwordType = "text";
    } else {
      this.passwordType = "password";
    }
  }

  /**
   * Gets the first available route from user privileges
   * @param privileges Array of privilege objects
   * @returns The first available route path or null
   */
  private getFirstAvailableRoute(privileges: any[]): string | null {
    if (!privileges || privileges.length === 0) {
      return null;
    }

    // Map pageType to route (similar to menu component logic)
    for (const permission of privileges) {
      if (permission.pageType === "Dashboard") {
        return "/dashboard";
      }
      if (permission.pageType === "Member Management") {
        return "/members";
      }
      if (permission.pageType === "Activity Logs") {
        return "/activity-logs";
      }
      if (permission.pageType === "Trainer Dashboard") {
        return "/trainer-dashboard";
      }
      if (permission.pageType === "Setting" && permission.pageName === "User Management") {
        return "/settings";
      }
      if (permission.pageType === "Products" && permission.pageName === "Products Listing") {
        return "/products-listing";
      }
      if (permission.pageType === "Purchasing" && permission.pageName === "Suppliers") {
        return "/suppliers-listing";
      }
      if (permission.pageType === "Sales" && permission.pageName === "Point of Sales") {
        return "/point-of-sale";
      }


    }

    return null;
  }

  private showLoginError(error: unknown, fallback: string): void {
    const detail = AppUtils.getHttpErrorMessage(error, fallback);

    if (AppUtils.isLicenceError(detail)) {
      this.error = true;
      this.errorMessage = detail + '!!' + '<br />' + ' Contact Us' + '<br />' + 'Email: rashid_562@hotmail.com'
        + '<br />' + ' Contact No: 923335478182';
      this.messageService.clear();
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail });
      return;
    }

    this.error = false;
    this.errorMessage = '';
    this.messageService.clear();
    this.messageService.add({ severity: 'error', summary: 'Error Message', detail });
  }

  login() {
    this.loading = true;
    this.appServicemanager.post('auth/actions/authenticate', this.user).subscribe((res: any) => {
      if (res.error === null) {
          this.user = res.data.user;
          localStorage.setItem('currentUser', JSON.stringify(this.user));
          localStorage.setItem('currentRole', JSON.stringify(res.data.role));
          localStorage.setItem('currentCompany', JSON.stringify(res.data.company[0]));
          localStorage.setItem('currentBranch', JSON.stringify(res.data.branch[0]));

          // calling img paths
          const appUtils = new AppUtils();
          appUtils.setImagesPath(this.user.company, this.user.branch);

          setTimeout(function () {
            // Code to be executed after the delay
            // This block of code will be executed after 1 second (1000 milliseconds)
          }, 1000);
          const token = res.data.token;
          const expiresInDuration = res.data.expiresIn;
          this.setAuthTimer(expiresInDuration);
          const now = new Date();
          const expirationDate = new Date(now.getTime() + expiresInDuration * 1000);
          this.saveAuthData(token, expirationDate);
          if (res.data.user.isDemo == true) {
            const queryParams = {
              company: this.user.company,
              branch: this.user.branch
            };
            this.route.navigateByUrl("members");
          }else{
            let returnUrl;
            if(res.data.role.name == "Trainer") {
              returnUrl = this.router.snapshot.queryParams['returnUrl'] || 'trainer-dashboard';
            } else {
              // Get the first available route from privileges
              const firstRoute = this.getFirstAvailableRoute(res.data.role.privileges);
              returnUrl = this.router.snapshot.queryParams['returnUrl'] || (firstRoute ? firstRoute.replace('/', '') : 'members');
            }

          if (returnUrl == "/" || returnUrl == "") {
            if(res.data.role.name == "Trainer") {
              this.route.navigateByUrl("trainer-dashboard");
            } else {
              // Get the first available route from privileges
              const firstRoute = this.getFirstAvailableRoute(res.data.role.privileges);
              const defaultRoute = firstRoute || "members";
              this.route.navigateByUrl(defaultRoute);
            }
          } else {
            this.route.navigateByUrl(returnUrl);
          }
        }
      }
      else {
        this.isAutoLoggingIn = false;
        this.showLoginError(res, 'Login failed. Please check your credentials and try again.');
      }
      this.loading = false;
    },
      (error) => {
        this.isAutoLoggingIn = false;
        this.showLoginError(error, 'Login failed. Please check your credentials and try again.');
        this.loading = false;
      });
  }


  logout() {
    this.clearAuthData();
    clearTimeout(this.tokenTimer as unknown as number);
    this.route.navigateByUrl('/login');
  }

  // addRecaptchaScript() {
  //   window['grecaptchaCallback'] = () => {
  //     this.renderReCaptcha();
  //   }
  //   (function (d, s, id, obj) {
  //     var js, fjs = d.getElementsByTagName(s)[0];
  //     // if (d.getElementById(id)) { return; }
  //     js = d.createElement(s); js.id = id;
  //     js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&render=explicit";
  //     fjs.parentNode.insertBefore(js, fjs);
  //   }(document, 'script', 'recaptcha-jssdk', this));

  // }

  // renderReCaptcha() {
  //   window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
  //     'sitekey': '6LeBcNofAAAAALKEmqYmmxrDJ7Fi9IpwDAPMVCtm',
  //     'expired-callback': () => {
  //       this.isDisableSignin = true;
  //       document.getElementById('loginUsername').focus();
  //     },
  //     'callback': (response) => {
  //       console.log(response);
  //       this.response = response;
  //       if (response == "") {
  //         // alert("You can't proceed!");
  //         this.isDisableSignin = true;
  //       } else {
  //         // alert("Thank you");
  //         this.isDisableSignin = false;
  //         document.getElementById('loginUsername').focus();
  //       }
  //     }
  //   });
  // }

  // onRecaptchaExpired = function () {
  //   this.isDisableSignin = true;
  // }

  verifyReCaptcha() {
    this.loading = true;
    let data = {
      token: this.response
    }
    this.appServicemanager.post('branches/' + AuthService.getLoggedInBranch() + '/users/actions/validate-recaptcha', data).subscribe((res: any) => {
      if (res.success) {
        this.login();
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'reCAPTCHA failed' });
        this.loading = false;
        setTimeout(() => {
          window.location.reload();

        }, 2000);

      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        this.loading = false;
        setTimeout(() => {
          window.location.reload();

        }, 2000);
      });
  }

  private setAuthTimer(duration: number) {
    console.log("Setting timer: " + duration);
    // this.tokenTimer = setTimeout(() => {
    //   this.logout();
    // }, duration * 1000);
  }

  private saveAuthData(token: string, expirationDate: Date) {
    localStorage.setItem('token', JSON.stringify(token));
    localStorage.setItem('expiration', JSON.stringify(expirationDate.toISOString()));
  }

  private clearAuthData() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentRole');
    localStorage.removeItem('token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('currentCompany');
  }

}
